/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { SendMessageApiArg, SentMessageData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    sendMessage: build.mutation<SentMessageData, SendMessageApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/v1/conversations/${queryArg.conversationId}/messages`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as sendMessageApi };
export const { useSendMessageMutation } = injectedRtkApi;
